// Shared date/time formatters — every user-facing timestamp renders in IST,
// regardless of the viewer's browser timezone. Backend stores UTC ISO strings.
const TZ = "Asia/Kolkata";

// "Today" and "this month" pinned to the IST calendar — never browser-local, never UTC.
export const todayIST = () =>
  new Intl.DateTimeFormat("en-CA", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());

export const thisMonthIST = () => todayIST().slice(0, 7);

export const thisYearIST = () => Number(todayIST().slice(0, 4));

// Current instant as an IST-offset ISO string (e.g. 2026-06-14T15:45:00.123+05:30) — matches backend storage.
export const nowISOIST = () => {
  const d = new Date();
  const ist = new Date(d.getTime() + 330 * 60 * 1000);
  const ms = String(ist.getUTCMilliseconds()).padStart(3, "0");
  return ist.toISOString().replace("Z", "").replace(/\.\d{3}$/, `.${ms}`) + "+05:30";
};

const DT_OPTS = {
  timeZone: TZ, day: "2-digit", month: "short", year: "numeric",
  hour: "2-digit", minute: "2-digit", hour12: true,
};
const T_OPTS = { timeZone: TZ, hour: "2-digit", minute: "2-digit", hour12: true };
const D_OPTS = { timeZone: TZ, day: "2-digit", month: "short", year: "numeric" };

export const fmtDateTimeIST = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-IN", DT_OPTS);
  } catch {
    return String(iso);
  }
};

export const fmtTimeIST = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-IN", T_OPTS);
  } catch {
    return String(iso).slice(11, 16);
  }
};

export const fmtDateIST = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-IN", D_OPTS);
  } catch {
    return String(iso).slice(0, 10);
  }
};
